import { render, staticRenderFns } from "./SingleTaskModal.vue?vue&type=template&id=886d5480&scoped=true&"
import script from "./SingleTaskModal.vue?vue&type=script&lang=js&"
export * from "./SingleTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./SingleTaskModal.vue?vue&type=style&index=0&id=886d5480&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886d5480",
  null
  
)

export default component.exports